import { createStore as createZustandStore } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
export * from 'zustand';
export { useShallow } from 'zustand/react/shallow';
export const createStore = (initializer, options = {}) => {
  const store = createZustandStore()(devtools(subscribeWithSelector(immer(initializer)), options.devtools));
  return store;
};